import { useEffect, useState } from "react";

import { isSupportChatAvailable } from "../helpers/helpers";

const POLL_MS = 1000;
// The Messenger boots a few seconds after sign-in; a disabled host or an ad
// blocker never lets it, so stop asking after a minute.
const POLL_LIMIT = 60;

/** Whether the support Messenger has booted, re-checked until it does. */
export const useSupportChatAvailable = (): boolean => {
  const [available, setAvailable] = useState(isSupportChatAvailable);

  useEffect(() => {
    if (available) return undefined;
    let tries = 0;
    const id = window.setInterval(() => {
      tries += 1;
      if (isSupportChatAvailable()) setAvailable(true);
      else if (tries < POLL_LIMIT) return;
      window.clearInterval(id);
    }, POLL_MS);
    return () => window.clearInterval(id);
  }, [available]);

  return available;
};
